import { ToastProvider } from "../../common/components/ui/toast/toast.provider"
import Dashboard from "../../common/components/layout/Dashboard"
import Toast from "../../common/components/ui/toast"
import { PurchaseReturnDashboard } from "./purchase-return-dashboard";

export default function PurchaseReturnDetailsPage() {

  return (
    <ToastProvider>
      <Dashboard>
          <PurchaseReturnDashboard />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

